export default "__VITE_ASSET__Dzx0pEot__"